import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Redirects old client URLs to include index.html
 * Example: /clients/atlantic-mental-health/ → /clients/atlantic-mental-health/index.html
 */
const ClientRedirect = () => {
  const { clientName } = useParams();
  
  useEffect(() => {
    // Redirect to the index.html version
    window.location.href = `/clients/${clientName}/index.html`;
  }, [clientName]);
  
  return null; // Component doesn't render anything
};

export default ClientRedirect;
